import React, { CSSProperties, MouseEventHandler, ReactNode } from "react";
import styled, { css } from "styled-components";

type ButtonStyleProps = {
  colorType: "primary" | "secondary" | "line" | "lineGray" | "gray";
};

export interface ButtonProps
  extends ButtonStyleProps,
    React.ButtonHTMLAttributes<HTMLButtonElement> {
  handleClick?: MouseEventHandler<HTMLButtonElement>;
  children: ReactNode;
  style?: CSSProperties;
}

const Button = ({
  handleClick,
  children,
  colorType,
  style,
  ...args
}: ButtonProps) => {
  return (
    <ButtonContainer
      colorType={colorType}
      onClick={handleClick}
      style={style}
      {...args}
    >
      <div className="buttonText">{children}</div>
    </ButtonContainer>
  );
};

export default Button;

const buttonType = {
  primary: css`
    background-color: #053692;

    .buttonText {
      color: #fff;
    }
  `,
  secondary: css`
    background-color: #e8f0ff;

    .buttonText {
      color: #1d68f9;
    }
  `,
  line: css`
    background-color: #fff;
    border: 1px solid #053692;

    .buttonText {
      color: #053692;
    }
  `,
  lineGray: css`
    background-color: #fff;
    border: 1px solid #d8dce5;

    .buttonText {
      color: #5e646d;
    }
  `,
  gray: css`
    background-color: #f2f4f7;

    .buttonText {
      color: #40444a;
    }
  `,
};

const ButtonContainer = styled.button<ButtonStyleProps>`
  border-radius: 1.2rem;
  width: 100%;
  min-width: max-content;
  box-sizing: border-box;
  padding: 1rem 2.4rem;

  ${(props) => buttonType[props.colorType]}

  .buttonText {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 150%;
  }

  :disabled {
    background-color: #e8ecf2;

    .buttonText {
      color: #b6bcc8;
    }
  }
`;
